<template>
    <div class="container">
        <van-nav-bar :title="goodsName"
                     left-text=""
                     right-text=""
                     left-arrow
                     fixed
                     @click-left="goBackHandle" />
        <div class="content">
            <div class="content-main">
                <template v-if="list.length > 0">
                    <div class="group"
                         v-for="item in list"
                         :key="item.id">
                        <div class="account">
                            <div class="account-left"
                                 :class="{ unsatisfied: showAccountHint && !item.finished }">
                                <p class="title">
                                    {{item.name}}
                                    <span>{{$t('selectedGroupNum')}}</span>
                                </p>
                                <p class="text">
                                    <span v-if="item.selectScope === 102">({{$t('priceZero')}})</span>
                                    <span v-else-if="item.selectScope === 103">({{$t('priceNoZero')}})</span>
                                    <span class="hint">{{item.totalChecked}}/Min:{{item.minSelectableCount}}/Max:{{item.maxSelectableCount}}</span>
                                </p>
                            </div>
                            <div class="account-right">
                                <van-icon name="success"
                                          class="icon"
                                          v-show="item.finished" />
                            </div>
                        </div>
                        <ul class="list"
                            v-if="item.attrs.length > 0">
                            <li class="list-item"
                                :class="{'active': inItem.count > 0}"
                                v-for="inItem in item.attrs"
                                :key="inItem.id">
                                <div class="item-left">
                                    <img v-lazy="cutImage(inItem.image, 200)"
                                         v-if="inItem.image">
                                    <img src="../assets/images/default.png"
                                         v-else>
                                </div>
                                <div class="item-right">
                                    <p class="name">{{inItem.name}}</p>
                                    <div class="chunk">
                                        <p class="price">{{inItem.price | filterPrice}}€</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <p class="empty-hint"
                           v-else>{{$t('notGroupMat')}}</p>
                    </div>
                </template>
                <p class="empty-hint"
                   v-else>{{$t('notDishesMat')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { queryDishesDetail } from "@/api";

export default {
    name: "RawMaterial",
    // 组件
    components: {
    
    },
    props: {},
    data () {
        return {
            goodsName: '',
            code: '',
            price: 0,
            image: '',
            list: [],
            showAccountHint: false
        };
    },
    // 计算属性
    computed: {
        ...mapState(['menuId'])
    },
    filters: {
        filterPrice (val) {
            if (val) {
                let value = Number(val)
                return value.toFixed(2).replace(/\./g, ',')
            } else {
                return 0
            }
        }
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 裁减图片
        cutImage (url, w = 200) {
            if (!url) return ''
            let suffix = url.substring(url.lastIndexOf('.'))
            return `${url}_${w}-${suffix}`
        },
        
        // 获取商品详情
        getDetails () {
            let params = {
                menuId: this.menuId,
                itemId: this.$route.params.id,
                type: 101,
                allergenIds: []
            }
            queryDishesDetail(params).then(res => {
                if (res.code === 20000) {
                    const resData = res.data
                    // 图片
                    this.image = resData.image || ''
                    // 菜品名称
                    this.goodsName = resData.name
                    // 菜品代号
                    this.code = resData.code
                    // 价格
                    this.price = resData.price
                    // 自定义原材料
                    let list = resData.specs || []
                    // selectScope 数量限制范围   101 全部   102 只针对免费   103 只针对非免费
                    // pricingType 计价类型   101 自定义   102 部分免费
                    list.forEach(item => {
                        // 总价格
                        item.totalPrice = 0
                        item.totalChecked = 0
                        if (item.minSelectableCount === 0) {
                            item.finished = true
                        } else {
                            item.finished = false
                        }
                        item.attrs.forEach(inItem => {
                            inItem.count = 0
                        })
                    })
                    this.list = list
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        
        // 返回
        goBackHandle () {
            this.$router.back()
        },
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        // 获取详情
        this.getDetails()
    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    padding-top: 46px;
    background: #f6f6f6;
    
    ::v-deep .van-nav-bar {
        .van-icon {
            font-size: 18px;
            color: #01000d;
            font-weight: 600;
        }
        
        .van-nav-bar__title {
            font-size: 18px;
            color: #01000d;
            font-weight: 600;
        }
    }
    .content {
        height: 100%;
        padding-bottom: 20px;
        .content-main {
            height: 100%;
            padding-top: 5px;
            overflow-y: auto;
            overflow-x: hidden;
            .group {
                margin-bottom: 20px;
                .account {
                    width: 100%;
                    padding: 10px 25px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background-color: #ffffff;
                    .account-left {
                        flex-grow: 1;
                        .title {
                            font-size: 14px;
                            color: #01000d;
                            margin-bottom: 6px;
                            text-align: left;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            span {
                                margin-left: 10px;
                            }
                        }
                        .text {
                            font-size: 14px;
                            color: #01000d;
                            font-width: 600;
                            text-align: left;
                        }
                        &.unsatisfied {
                            .title {
                                color: #e20714;
                            }
                            .text {
                                color: #e20714;
                            }
                        }
                    }
                    .account-right {
                        flex-shrink: 0;
                        width: 30px;
                        height: 100%;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .icon {
                            font-size: 24px;
                            color: #00ad8f;
                        }
                    }
                }
                .list {
                    padding-left: 25px;
                    padding-right: 25px;
                    .list-item {
                        margin-top: 15px;
                        width: 100%;
                        height: 84px;
                        padding-left: 20px;
                        padding-right: 20px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background-color: #ffffff;
                        .item-left {
                            width: 60px;
                            height: 60px;
                            flex-shrink: 0;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 4px;
                            }
                        }
                        .item-right {
                            flex-grow: 1;
                            height: 100%;
                            padding-left: 26px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            overflow: hidden;
                            .name {
                                width: 100%;
                                margin-bottom: 6px;
                                font-size: 16px;
                                color: #01000d;
                                text-align: left;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                            .chunk {
                                width: 100%;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .price {
                                    font-size: 16px;
                                    //color: #606266;
                                    color: #e20714;
                                }
                                .stepper {
                                    display: flex;
                                    flex-grow: 1;
                                    justify-content: flex-end;
                                    align-items: center;
                                    .dice {
                                        width: 20px;
                                        height: 20px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        font-size: 14px;
                                        font-weight: 600;
                                        border-radius: 4px;
                                    }
                                    .count {
                                        margin-left: 10px;
                                        margin-right: 10px;
                                        font-size: 14px;
                                        color: #01000d;
                                    }
                                    .minus {
                                        color: #2f7a59;
                                        background-color: #e3f1ee;
                                    }
                                    .add {
                                        color: #ffffff;
                                        background-color: #2f7a59;
                                    }
                                }
                            }
                        }
                        &.active {
                            border: 1px solid #197340;
                        }
                    }
                }
            }
            .empty-hint {
                width: 100%;
                height: 60px;
                text-align: center;
                line-height: 60px;
                color: #8f92a1;
                font-size: 16px;
            }
        }
    }
}
</style>
